import type { User } from './types';

export const extractUserName = (data: User) => {
  if (data.middleName) return `${data.firstName} ${data.middleName} ${data.lastName}`;
  return `${data.firstName} ${data.lastName}`;
}
